/**
 * Deli treats data
 * Represents treats and pantry items available at the deli
 */

const deliTreats = [
  {
    id: 1,
    name: "Fresh Fruit Salad",
    description: "By weight",
    category: "treats"
  },
  {
    id: 2,
    name: "Rugelach",
    description: "By weight",
    category: "treats"
  },
  {
    id: 3,
    name: "Rice Pudding",
    description: "By weight",
    category: "treats"
  },
  {
    id: 4,
    name: "Chips",
    category: "treats"
  },
  {
    id: 5,
    name: "7-Layer Cake",
    category: "treats"
  },
  {
    id: 6,
    name: "Sour Cream Coffee Cake",
    description: "By weight",
    category: "treats"
  },
  {
    id: 7,
    name: "Homemade Cakes",
    category: "treats"
  },
  {
    id: 8,
    name: "Cookies",
    category: "treats"
  },
  {
    id: 9,
    name: "Cheesecake",
    description: "With various toppings",
    category: "treats"
  },
  {
    id: 10,
    name: "Brownies",
    category: "treats"
  },
  {
    id: 11,
    name: "Halvah",
    category: "treats"
  },
  {
    id: 12,
    name: "Pepperidge Farm Products",
    category: "treats"
  },
  {
    id: 13,
    name: "Candy",
    category: "treats"
  },
  {
    id: 14,
    name: "Homemade Pies",
    category: "treats"
  }
];

module.exports = deliTreats;